/*
 *  -----------------------------------------------------------------------
 *    <copyright file="plugin-filters-grid.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import React from 'react';
import ExpandableGrid from 'views/components/core/expandable/grid';

const PluginFiltersGrid = ({ filters }: any) => (
    <ExpandableGrid
        customKey="filters"
        items={filters}
        showPager
        groupable={false}
        showFirstColumn={false}
        scrollable="scrollable"
        reorderable
        pageable={false}
        resizable
        addScroll
        options={{
            allowExcelExport: false,
            allowExpandCollapseAll: false,
            useFilterChips: true,
        }}
        columns={[
            {
                label: 'Table',
                field: 'table',
                minWidth: 160,
            },
            {
                label: 'Name',
                field: 'name',
                minWidth: 160,
            },
            {
                label: 'Key',
                field: 'id',
                minWidth: 190,
            },
            {
                label: 'Tag(s)',
                field: 'tags',
                minWidth: 250,
            },
        ]}
    />
);

export default PluginFiltersGrid;
